$(function() {
  $('.modal').on('shown.bs.modal', function(event) {
    var planToSelect = $(event.relatedTarget).attr('data-serviceplan');
    
    if(typeof planToSelect !== 'undefined') {
      $(this).find('input[type="radio"]').removeAttr('checked');
      $(this).find('input[type="radio"][value="' + planToSelect +'"]').attr('checked', true);
    }
  });
});